/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';
import models from './state/models';
import sockets from './sockets';

import type { State } from './types';

export default combineReducers<State>({
  models,
  sockets,
});
